<template>
    <create-instance-form v-if="isLogged"></create-instance-form>
    <sign-up-form v-else />
</template>

<script>
import SignUpForm from '@/components/auth/signUpForm.vue';
import CreateInstanceForm from '@/components/instance/createInstanceForm';
import { getAccessToken } from '@/api/auth.ts';

export default {
    name: 'CreatePage',
    components: {
        CreateInstanceForm,
        SignUpForm,
    },
    data() {
        return {
            isLogged: false,
        };
    },
    async created() {
        const token = await getAccessToken();
        this.isLogged = !!token;
    },
};
</script>

<style lang="scss"></style>
